export const actionUserInfo = (state, userInfo) => {
  state.userInfo = userInfo
}
export const actionAllSelect = (state, allSelect) => {
  state.allSelect = allSelect
}
export const actionSence = (state, sence) => {
  state.sence = sence
}
export const actionToast = (state, toast) => {
  state.toast = toast
}
export const actionLoadingToast = (state, loadingToast) => {
  state.loadingToast = loadingToast
}
